import React from "react";
import styles from "./SummaryHeader.module.scss";
import classNames from "classnames";
import { Text, Span } from "../Typography";
import { ComponentLoader } from "../Loaders"
import { SolidSquareIcon } from "./SolidIcon";
import Tooltip from "./Tooltip";
import { CopyButton } from ".";

/**
 * @deprecated - DONT USE IN NEW FEATURES. Use "Metric Items" instead.
 */
export const SummaryHeaderLoader = () => {
    return <div className={styles['summary-loader']}>
        <ComponentLoader/>
    </div>
};

/**
 * @deprecated - DONT USE IN NEW FEATURES. Use "Metric Items" instead.
 */
export const SummaryHeaderInfoItem = ({ Icon, value, ValueIcon, valueIconStyle, valueTooltip, valueHasCopy, valueIconClassName, label, className, style, iconBgColor, iconFgColor, isTooltipNowrap=false }) => {
    return <div className={classNames(styles['summary-info-item'], className, { [styles['no-icon']]: !Icon })} style={style}>
        {Icon && <SolidSquareIcon bgColor={iconBgColor} fgColor={iconFgColor}>
            <Icon/>
        </SolidSquareIcon>}
        <div className={styles['summary-info-values']}>
            <div>{ValueIcon && <ValueIcon style={valueIconStyle} className={valueIconClassName}/>}<Span bold ellipsis>{value}</Span>{valueTooltip && <Tooltip nowrap={isTooltipNowrap} className={styles['value-tooltip']}>{valueTooltip}</Tooltip>}{valueHasCopy && <CopyButton className={styles['value-copy']} text={value}/>}</div>
            <div><Span color="grey-7">{label}</Span></div>
        </div>
    </div>
};

/**
 * @deprecated - DONT USE IN NEW FEATURES. Use "Metric Items" instead.
 */
export const SummaryHeaderItem = ({ Icon, value, label, unit, className, style, color, iconStyle }) => {
    return <div className={classNames(styles['summary-item'], className, { [styles['no-icon']]: !Icon })} style={style}>
        {Icon && <Icon style={iconStyle}/>}
        <div>
            <div className={classNames(styles['summary-value'], color && styles[color])}>{value}{unit && <span>{unit}</span>}</div>
            <div className={styles['summary-label']}>{label}</div>
        </div>
    </div>
};

/**
 * @deprecated - DONT USE IN NEW FEATURES. Use "Metric Items" instead.
 */
export const SummaryHeader = ({ children, className, style, title, dataTestId }) => {
    return <div className={classNames(styles["summary-header"], className)} style={style}> {title && <Text level="15" bold>{title}</Text>}
        <div className={classNames(styles["base"])} data-testid={dataTestId}>
            {children}
        </div>
    </div>
};
